const toFiniteNumber = (value) => {
    if (value === null || value === undefined || value === "")
    {
        return undefined;
    }

    const number = Number(value);

    return Number.isFinite(number) ? number : undefined;
};

const isLatitude = (value) => value !== undefined && value >= -90 && value <= 90;
const isLongitude = (value) => value !== undefined && value >= -180 && value <= 180;

export const getStaffCurrentCheckInZone = (event) => {
    const latitude = toFiniteNumber(event?.check_latitude);
    const longitude = toFiniteNumber(event?.check_longitude);
    const radius = toFiniteNumber(event?.check_radius);

    if (
        !isLatitude(latitude) ||
        !isLongitude(longitude) ||
        radius === undefined ||
        radius <= 0
    )
    {
        return undefined;
    }

    return { latitude, longitude, radius };
};

export const getStaffScanLocation = (snapshot, worker) => {
    if (!snapshot || snapshot.has_location === false)
    {
        return undefined;
    }

    const scanLatitude = toFiniteNumber(snapshot.scan_latitude ?? snapshot.latitude);
    const scanLongitude = toFiniteNumber(snapshot.scan_longitude ?? snapshot.longitude);
    const rawDistanceFromZone = toFiniteNumber(
        snapshot.distance_from_zone ?? snapshot.getDistanceFromZone
    );
    const reason = String(snapshot.reason || "").trim().toUpperCase();

    if (!isLatitude(scanLatitude) || !isLongitude(scanLongitude))
    {
        return undefined;
    }

    const location = {
        scan: {
            id: snapshot.id,
            created_at: snapshot.created_at,
            latitude: scanLatitude,
            longitude: scanLongitude,
            distance_from_zone: rawDistanceFromZone !== undefined && rawDistanceFromZone >= 0 ?
                rawDistanceFromZone :
                undefined,
            result: snapshot.result ?? (
                reason === "OUTSIDE_RADIUS" ? "outside_zone" :
                    reason === "WITHIN_RADIUS" ? "inside_zone" : undefined
            ),
            worker,
        },
    };

    const zoneLatitude = toFiniteNumber(snapshot.zone_latitude);
    const zoneLongitude = toFiniteNumber(snapshot.zone_longitude);
    const zoneRadius = toFiniteNumber(snapshot.zone_radius);

    if (
        isLatitude(zoneLatitude) &&
        isLongitude(zoneLongitude) &&
        zoneRadius !== undefined &&
        zoneRadius > 0
    )
    {
        location.zone = {
            latitude: zoneLatitude,
            longitude: zoneLongitude,
            radius: zoneRadius,
        };
    }

    return location;
};

export const getStaffScanMapPositions = ({ scan, zone } = {}) => {
    const latitude = toFiniteNumber(scan?.latitude);
    const longitude = toFiniteNumber(scan?.longitude);

    if (!isLatitude(latitude) || !isLongitude(longitude))
    {
        return undefined;
    }

    const positions = {
        scan: [ latitude, longitude ],
    };

    const zoneLatitude = toFiniteNumber(zone?.latitude);
    const zoneLongitude = toFiniteNumber(zone?.longitude);
    const zoneRadius = toFiniteNumber(zone?.radius);

    if (
        isLatitude(zoneLatitude) &&
        isLongitude(zoneLongitude) &&
        zoneRadius !== undefined &&
        zoneRadius > 0
    )
    {
        positions.zone = {
            center: [ zoneLatitude, zoneLongitude ],
            radius: zoneRadius,
        };
    }

    return positions;
};

const StaffScanLocationHelper = {
    getLocation: getStaffScanLocation,
    getMapPositions: getStaffScanMapPositions,
    getCurrentCheckInZone: getStaffCurrentCheckInZone,
};

export default StaffScanLocationHelper;
